import { render, staticRenderFns } from "./AbkEventForm.vue?vue&type=template&id=185c8dd9&scoped=true&"
import script from "./AbkEventForm.vue?vue&type=script&lang=js&"
export * from "./AbkEventForm.vue?vue&type=script&lang=js&"
import style0 from "./AbkEventForm.vue?vue&type=style&index=0&id=185c8dd9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185c8dd9",
  null
  
)

export default component.exports